module.exports = __webpack_public_path__ + "static/media/vormats.148e3e78.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/vormats.webp
// module id = 76
// module chunks = 0